import {
	ReactElement,
	useMemo
} from "react";
import { TruncatingList, TruncatingListWrappingBehavior } from "client/Components";
import styles from "./RecipientList.module.less";

export type RecipientListProps = {
	value: string;
	wrappingBehavior?: TruncatingListWrappingBehavior;
	trackingId: string;
	label: string;
};

export const RecipientList = (props: RecipientListProps): ReactElement => {
	const {
		value,
		wrappingBehavior = "wrap",
		trackingId,
		label
	} = props;

	const recipients = useMemo(
		(): readonly string[] => {
			return value.split(";")
				.filter(x => x.trim() !== "");
		},
		[value]
	);

	return (
		<div className={styles.root}>
			<span className={styles.recipientTitle}>
				{label}:
			</span>
			<TruncatingList
				items={recipients}
				wrappingBehavior={wrappingBehavior}
				trackingId={trackingId}
				shouldShowAtLeastOne
			>
				{(item: string): ReactElement => (
					<>
						{item}
					</>
				)}
			</TruncatingList>
		</div>
	);
};
RecipientList.displayName = "RecipientList";